'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 83963;
});
$p.b = (function() {
  return "Tel";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Tel";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Tel$", ({
  gz: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Tel$ };
